/**
 * 代码编辑器常量
 */
(function(global, fn) {
    global.CONSTS = fn();
  })(window, function() {
    const isMac =
      navigator.platform == "Mac68K" ||
      navigator.platform == "MacPPC" ||
      navigator.platform == "Macintosh" ||
      navigator.platform == "MacIntel";
    const IS_CTRL_KEY = isMac ? "metaKey" : "ctrlKey";
    return {
      //默认空的工作空间
      EMPTY_WORK_SPACE: '<xml id="startBlocks" style="display: none"><block type="start_start" id="11111" x="40" y="40"></block></xml>',
      //账号登陆地址
      LOGIN_ADDRESS: "https://dev-api.nuwarobotics.com/v1/oauth2/authorize?client_id=9D272464-0114-441A-94B8-448A85456E75&state=123&connection=xiaomi&response_type=token&device_id=12345&redirect_uri=",
      //用户登陆后需要回跳的地址保存在sessionStorage中的键值
      LOGIN_CALLBACK_KEY: "developer_tool_login_callback_url",
      CTRL_KEY_CODE: isMac ? 91 : 17, //windowsctrl键码，在mac上对应meta键
      IS_CTRL_KEY: IS_CTRL_KEY, //判断键盘事件在windows下是否按下ctrl键，在mac下是否按下了meta键
      //从右到左排列的语言
      LANG_RTL: ['ar', 'fa', 'he', 'lki']
    };
  });
  